import { Card, Container, Divider, Flex, Skeleton, Text } from '@mantine/core';
import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GridCell from '../../components/elements/GridCell';
import SearchRegistrationIdSubUserForm from '../../components/forms/SearchRegistrationIdSubUserForm';
import ModalConfirmActivationGIGR from '../../components/fragments/ModalConfimActivationGIGR';
import IconMerchant from '../../components/icons/IconMerchant';
import { AppContext } from '../../contexts';
import { clearRedux, fetchMerchantById, fetchUpdateMerchantStatus } from './actions';
import SwitchCustom from '../../components/elements/SwitchCustom';

export default function ActivationByMerchant() {

  const { setBreadcrumbs } = useContext(AppContext);
  const dispatch = useDispatch();
  const [afterSubmit, setAfterSubmit] = useState(false);
  const [modalConfirmation, setModalConfirmation] = useState({
    opened: false,
    registrationId: null
  });
  const {
    dataMerchantById, isLoadingMerchantById, messageMerchantById,
    dataUpdateMerchantStatus, isLoadingUpdateMerchantStatus
  } = useSelector((state) => state?.gigrActivation);

  useEffect(() => {
    setBreadcrumbs([{
      name: 'Aktivasi Menu GI/GR',
      to: '/gigr-activation'
    }, 'Aktivasi per Pangkalan']);
    dispatch(clearRedux('MerchantById'));
  }, []);

  useEffect(() => {
    if (afterSubmit && dataUpdateMerchantStatus
      && !isLoadingUpdateMerchantStatus) {
      dispatch(fetchMerchantById(dataMerchantById?.data?.registrationId));
    }
  }, [dataUpdateMerchantStatus, isLoadingUpdateMerchantStatus]);

  const handleSearch = (val) => {
    setAfterSubmit(true);
    dispatch(fetchMerchantById(val.registrationId));
  };

  const handleReset = (key) => {
    dispatch(clearRedux(key));
  };

  const _handleChangeStatus = (e) => {
    const status = e.target.checked ? 1 : 0;
    setModalConfirmation({
      opened: true,
      registrationId: dataMerchantById?.data?.registrationId,
      status: status
    });
  };

  const _handleClose = () => {
    setModalConfirmation({
      opened: false,
      registrationId: null,
      status: null
    });
  };

  const _handleDeactive = () => {
    dispatch(fetchUpdateMerchantStatus(dataMerchantById?.data?.registrationId,
      { status: modalConfirmation.status }, 'details'));
    _handleClose();
  };


  return (
    <Container size="md">
      <Card p={30} withBorder>
        <Text fw={600}>Aktivasi Menu GI/GR</Text>
        <Divider my={16} />
        <SearchRegistrationIdSubUserForm
          buttonLabel="Cari Pangkalan"
          handleReset={() => handleReset('MerchantById')}
          handleSubmit={handleSearch}
          label="ID Pangkalan"
          message={messageMerchantById}
        />

        {isLoadingMerchantById && (
          <Skeleton height={40} mt={16} radius="md" />
        )}

        {dataMerchantById && dataMerchantById?.data &&
          <>
            <Text mt={24}>Menampilkan data berdasarkan pencarian
              <strong>"ID Pangkalan"</strong></Text>
            <Card px={21} py={28} radius={12} withBorder>
              <Flex align={'center'} gap={16} mb={16}>
                <IconMerchant />
                <Text fw={600} fz={16}>{dataMerchantById?.data?.storeName}</Text>
              </Flex>
              <GridCell data={dataMerchantById?.data?.registrationId} label={'ID Pangkalan'} />
              <GridCell data={`${dataMerchantById?.data?.agen?.id} - ${dataMerchantById?.data?.agen?.name}`} label={'ID & Nama Agen'} />
              <GridCell data={dataMerchantById?.data?.provinceName} label={'Provinsi'} />
              <GridCell data={dataMerchantById?.data?.cityName} label={'Kota/Kabupaten'} />
              <GridCell data={dataMerchantById?.data?.districtName} label={'Kecamatan'} />
              <GridCell data={dataMerchantById?.data?.villageName} label={'Kelurahan'} />
              <Divider my={16} />
              <GridCell center data={
                <Flex align={'center'} gap={8}>
                  : <SwitchCustom
                    checked={dataMerchantById?.data?.isGiGrActivated}
                    fw={500}
                    offLabel="Tidak Aktif"
                    onChange={_handleChangeStatus} onLabel="Aktif" radius={'xl'} size="xl" />
                </Flex>
              } label={'Status'} />
            </Card>
          </>
        }
      </Card>

      <ModalConfirmActivationGIGR
        onClose={() => _handleClose()}
        onConfirm={() => _handleDeactive()}
        opened={modalConfirmation.opened}
        registrationId={modalConfirmation.registrationId}
        type={modalConfirmation.status === 0 ? 'diactivated' : 'activated'}
      />
    </Container>
  );
}
